import type { Middleware } from 'openapi-fetch';

import { auth0Client } from 'src/auth0Client';
import { authHelpers } from 'src/utils/authHelpers';

export const addAuthHeader: Middleware = {
  async onRequest({ request }) {
    const auth0 = await auth0Client;
    const token = await authHelpers.getAccessTokenSilently(auth0);

    if (!request.headers.has('Accept')) {
      request.headers.set('Accept', 'application/json');
    }

    if (!request.headers.has('Authorization')) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }

    return request;
  },
};
